<template>
  <div
    v-if="canPledge"
    ref="barRef"
    class="fixed bottom-0 left-0 right-0 lg:hidden z-30 bg-gray-500 border-t border-[#6E747C] px-4 py-2 flex items-center justify-between gap-3"
    :style="{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)' }"
  >
    <div class="flex flex-col flex-shrink-0">
      <span class="text-12px text-gray-150">{{ $t('campaigns.show.total') }}</span>
      <span class="text-16px font-medium text-white">{{ formattedTotalAmount }}</span>
    </div>
    <pledge-button class="flex flex-1 max-w-[200px]" />
  </div>
</template>

<script>
import { computed, inject, onUnmounted, ref, watch } from 'vue'
import { formatCurrency } from '../../../../components/exchange_rates.js'

const HEIGHT_VAR = '--mobile-pledge-bar-height'

export default {
  name: 'MobilePledgeBar',
  setup() {
    const rewardsData = inject('rewardsData', computed(() => []))
    const rewardQuantities = inject('rewardQuantities', computed(() => ({})))
    const canPledge = inject('canPledge', computed(() => false))

    const totalAmount = computed(() => {
      const rewards = rewardsData.value || []
      return rewards.reduce((sum, reward) => {
        const qty = rewardQuantities.value[reward.id] || 0
        return sum + qty * Number(reward.price || 0)
      }, 0)
    })

    const formattedTotalAmount = computed(() => {
      return formatCurrency(totalAmount.value)
    })

    const barRef = ref(null)
    let resizeObserver = null

    const setHeightVar = (px) => {
      document.documentElement.style.setProperty(HEIGHT_VAR, `${px}px`)
    }

    const clearHeightVar = () => {
      document.documentElement.style.removeProperty(HEIGHT_VAR)
    }

    const observeBar = (el) => {
      if (resizeObserver) {
        resizeObserver.disconnect()
        resizeObserver = null
      }
      if (!el) {
        clearHeightVar()
        return
      }
      let lastHeight = 0
      const update = () => {
        const height = el.getBoundingClientRect().height || el.offsetHeight
        if (height > 0 && height !== lastHeight) {
          lastHeight = height
          setHeightVar(height)
        }
      }
      update()
      resizeObserver = new ResizeObserver(update)
      resizeObserver.observe(el)
    }

    watch(barRef, observeBar, { flush: 'post' })

    onUnmounted(() => {
      if (resizeObserver) resizeObserver.disconnect()
      clearHeightVar()
    })

    return {
      barRef,
      formattedTotalAmount,
      canPledge
    }
  }
}
</script>
